// AUTO-GENERATED by /app/backend/scripts/generate_quotes.py — do not edit by hand.
// 400 calm, habit-themed quotes rotated daily by day-of-year.
export const QUOTES = [
  {
    "text": "We are what we repeatedly do. Excellence is not an act, but a habit.",
    "author": "Aristotle"
  },
  {
    "text": "Small daily improvements compound into results that astonish you.",
    "author": "Anonymous"
  },
  {
    "text": "The secret of getting ahead is getting started.",
    "author": "Mark Twain"
  },
  {
    "text": "Adopt the pace of nature: her secret is patience.",
    "author": "Ralph Waldo Emerson"
  },
  {
    "text": "A calm mind is the foundation every durable thing is built upon.",
    "author": "Anonymous"
  },
  {
    "text": "Do the difficult things while they are easy.",
    "author": "Lao Tzu"
  },
  {
    "text": "How we spend our days is how we spend our lives.",
    "author": "Annie Dillard"
  },
  {
    "text": "The man who moves a mountain begins by carrying small stones.",
    "author": "Confucius"
  },
  {
    "text": "Waste no more time arguing what a good person should be. Be one.",
    "author": "Marcus Aurelius"
  },
  {
    "text": "Every morning you are born again. What you do today matters most.",
    "author": "Anonymous"
  },
  {
    "text": "Knowing is not enough; we must apply. Willing is not enough; we must do.",
    "author": "Goethe"
  },
  {
    "text": "Attention is the rarest and purest form of generosity.",
    "author": "Simone Weil"
  },
  {
    "text": "Tilling the same small field daily yields more than chasing distant harvests.",
    "author": "Anonymous"
  },
  {
    "text": "Begin at once to live, and count each separate day as a separate life.",
    "author": "Seneca"
  },
  {
    "text": "The quieter you become, the more you can hear.",
    "author": "Ram Dass"
  },
  {
    "text": "Progress is built in the margins no one else notices.",
    "author": "Anonymous"
  },
  {
    "text": "Routine frees the mind to wander toward what matters.",
    "author": "Anonymous"
  },
  {
    "text": "Nothing is particularly hard if you divide it into small jobs.",
    "author": "Henry Ford"
  },
  {
    "text": "A tree grows patient and unbothered; become like the tree.",
    "author": "Anonymous"
  },
  {
    "text": "The quality of a person's life is in direct proportion to their commitment.",
    "author": "Vince Lombardi"
  },
  {
    "text": "You do not rise to the level of your goals; you fall to your systems.",
    "author": "James Clear"
  },
  {
    "text": "First say what you would be, then do what you have to do.",
    "author": "Epictetus"
  },
  {
    "text": "Look deep into nature, and then you will understand everything better.",
    "author": "Albert Einstein"
  },
  {
    "text": "Discipline is choosing between what you want now and what you want most.",
    "author": "Abraham Lincoln"
  },
  {
    "text": "Stillness is not the absence of effort but its truest form.",
    "author": "Anonymous"
  },
  {
    "text": "Go confidently in the direction of your dreams.",
    "author": "Henry David Thoreau"
  },
  {
    "text": "Each gentle step, taken daily, reshapes the landscape of a life.",
    "author": "Anonymous"
  },
  {
    "text": "The soul that is calm will always find the right moment.",
    "author": "Anonymous"
  },
  {
    "text": "A good traveler has no fixed plans and is not intent on arriving.",
    "author": "Lao Tzu"
  },
  {
    "text": "Habit is the intersection of knowledge, skill, and desire.",
    "author": "Stephen Covey"
  },
  {
    "text": "The measure of wisdom is how calmly you meet the day.",
    "author": "Anonymous"
  },
  {
    "text": "Nothing in the world can take the place of persistence.",
    "author": "Calvin Coolidge"
  },
  {
    "text": "Water carves canyons not by force but by faithful return.",
    "author": "Anonymous"
  },
  {
    "text": "To improve is to change; to be perfect is to change often.",
    "author": "Winston Churchill"
  },
  {
    "text": "Mindfulness is the lamp that keeps the path visible.",
    "author": "Anonymous"
  },
  {
    "text": "One who is contented with what they have done will never become famous.",
    "author": "Leonardo da Vinci"
  },
  {
    "text": "Consistency is the craft beneath the craft.",
    "author": "Anonymous"
  },
  {
    "text": "Self-discipline begins with the mastery of your thoughts.",
    "author": "Napoleon Hill"
  },
  {
    "text": "Do not hurry; do not rest.",
    "author": "Goethe"
  },
  {
    "text": "Each small act of attention stitches purpose into the day.",
    "author": "Anonymous"
  },
  {
    "text": "The seed of every great change is a quiet daily decision.",
    "author": "Anonymous"
  },
  {
    "text": "Without deviation from the norm, progress is not possible.",
    "author": "Frank Zappa"
  },
  {
    "text": "Slow is smooth; smooth is far.",
    "author": "Anonymous"
  },
  {
    "text": "Growth is not a sudden arrival but a steady accumulation.",
    "author": "Anonymous"
  },
  {
    "text": "Muddy water, left still, becomes clear.",
    "author": "Lao Tzu"
  },
  {
    "text": "The present moment always will have been.",
    "author": "Anonymous"
  },
  {
    "text": "Keep your face always toward the sunshine, and shadows fall behind.",
    "author": "Walt Whitman"
  },
  {
    "text": "Focus on the process; the destination will arrange itself.",
    "author": "Anonymous"
  },
  {
    "text": "An unexamined habit is a borrowed life.",
    "author": "Anonymous"
  },
  {
    "text": "Do what you can, with what you have, where you are.",
    "author": "Theodore Roosevelt"
  },
  {
    "text": "Small acts, repeated faithfully, carve canyons through stone.",
    "author": "Anonymous"
  },
  {
    "text": "First say to yourself what you would be, then do what you have to do.",
    "author": "Epictetus"
  },
  {
    "text": "Routine is the quiet architecture of a meaningful life.",
    "author": "Anonymous"
  },
  {
    "text": "Each day is a thread; the weaving is yours to choose.",
    "author": "Anonymous"
  },
  {
    "text": "Undisturbed calmness of mind is the attainment of peace.",
    "author": "Patanjali"
  },
  {
    "text": "Consistency outlasts intensity every single time.",
    "author": "Anonymous"
  },
  {
    "text": "A gentle discipline, held long enough, reshapes the self entirely.",
    "author": "Anonymous"
  },
  {
    "text": "To improve is to change; to perfect is to change often.",
    "author": "Winston Churchill"
  },
  {
    "text": "The roots of education are bitter, but the fruit is sweet.",
    "author": "Aristotle"
  },
  {
    "text": "Stillness is not absence — it is the ground from which action grows.",
    "author": "Anonymous"
  },
  {
    "text": "Nature does not hurry, yet everything is accomplished.",
    "author": "Lao Tzu"
  },
  {
    "text": "Habits are the invisible hands shaping tomorrow's version of you.",
    "author": "Anonymous"
  },
  {
    "text": "Begin anywhere. Each honest step compounds into direction.",
    "author": "Anonymous"
  },
  {
    "text": "We do not rise to the level of our goals; we fall to the level of our systems.",
    "author": "James Clear"
  },
  {
    "text": "Think lightly of yourself and deeply of the world.",
    "author": "Miyamoto Musashi"
  },
  {
    "text": "Patience is the companion of wisdom.",
    "author": "Augustine of Hippo"
  },
  {
    "text": "What you practice in private appears in public.",
    "author": "Anonymous"
  },
  {
    "text": "Lose an hour in the morning and you will spend the day hunting it.",
    "author": "Richard Whately"
  },
  {
    "text": "Water shapes itself around obstacles — and still moves forward.",
    "author": "Anonymous"
  },
  {
    "text": "The soul is dyed the color of its thoughts.",
    "author": "Marcus Aurelius"
  },
  {
    "text": "Growth is quiet. It rarely announces itself until it's done.",
    "author": "Anonymous"
  },
  {
    "text": "A person who never made a mistake never tried anything new.",
    "author": "Albert Einstein"
  },
  {
    "text": "Tend one small fire daily rather than dreaming of a bonfire.",
    "author": "Anonymous"
  },
  {
    "text": "To know what you know and what you do not know — that is true knowledge.",
    "author": "Confucius"
  },
  {
    "text": "Mindfulness is simply meeting each moment without flinching.",
    "author": "Anonymous"
  },
  {
    "text": "Nothing in the world can take the place of persistent effort.",
    "author": "Calvin Coolidge"
  },
  {
    "text": "Every morning is a clean ledger; what will you write today?",
    "author": "Anonymous"
  },
  {
    "text": "In dwelling, live close to the ground. In thinking, keep to the simple.",
    "author": "Lao Tzu"
  },
  {
    "text": "Calm is a superpower refined through daily repetition.",
    "author": "Anonymous"
  },
  {
    "text": "Self-discipline is the bridge between intention and achievement.",
    "author": "Anonymous"
  },
  {
    "text": "What we plant in the soil of contemplation we harvest in the field of life.",
    "author": "Meister Eckhart"
  },
  {
    "text": "Slow is smooth; smooth is lasting.",
    "author": "Anonymous"
  },
  {
    "text": "Live as if you were to die tomorrow. Learn as if you were to live forever.",
    "author": "Mahatma Gandhi"
  },
  {
    "text": "Mastery is just consistent attention, held without drama.",
    "author": "Anonymous"
  },
  {
    "text": "He who is not courageous enough to take risks will accomplish nothing.",
    "author": "Muhammad Ali"
  },
  {
    "text": "Peace comes not from the absence of noise, but from a settled center.",
    "author": "Anonymous"
  },
  {
    "text": "An investment in knowledge pays the best interest.",
    "author": "Benjamin Franklin"
  },
  {
    "text": "The habit you build today is the ease you carry tomorrow.",
    "author": "Anonymous"
  },
  {
    "text": "It is not the mountain we conquer but ourselves.",
    "author": "Edmund Hillary"
  },
  {
    "text": "Focus is the art of knowing what not to attend to.",
    "author": "Anonymous"
  },
  {
    "text": "Simplicity is the ultimate sophistication.",
    "author": "Leonardo da Vinci"
  },
  {
    "text": "Each small yes to discipline is a small no to drift.",
    "author": "Anonymous"
  },
  {
    "text": "To read without reflecting is like eating without digesting.",
    "author": "Edmund Burke"
  },
  {
    "text": "The quiet accumulation of honest effort is its own reward.",
    "author": "Anonymous"
  },
  {
    "text": "Small acts, faithfully repeated, carve canyons.",
    "author": "Anonymous"
  },
  {
    "text": "First forget inspiration. Habit is more dependable.",
    "author": "Octavia Butler"
  },
  {
    "text": "The man who moves a mountain begins carrying small stones.",
    "author": "Confucius"
  },
  {
    "text": "Routine is not the enemy of freedom; it is its scaffold.",
    "author": "Anonymous"
  },
  {
    "text": "Mastery hides inside the unremarkable Tuesday.",
    "author": "Anonymous"
  },
  {
    "text": "A calm mind sharpens every action it guides.",
    "author": "Anonymous"
  },
  {
    "text": "The quality of a moment decides the quality of a life.",
    "author": "Anonymous"
  },
  {
    "text": "What you practice in private shows up in public.",
    "author": "Anonymous"
  },
  {
    "text": "To know what you know and what you do not know — that is knowledge.",
    "author": "Confucius"
  },
  {
    "text": "Sow a thought, reap an action; sow an action, reap a habit.",
    "author": "William James"
  },
  {
    "text": "Growth is quiet. Listen for it anyway.",
    "author": "Anonymous"
  },
  {
    "text": "He who is not courageous enough will accomplish nothing.",
    "author": "Muhammad Ali"
  },
  {
    "text": "Each day is a small life; live it accordingly.",
    "author": "Anonymous"
  },
  {
    "text": "Knowing is not enough; we must apply.",
    "author": "Johann Wolfgang von Goethe"
  },
  {
    "text": "Let your roots drink before your branches reach.",
    "author": "Anonymous"
  },
  {
    "text": "Wherever you are, be all there.",
    "author": "Jim Elliot"
  },
  {
    "text": "Stillness is where clarity is born.",
    "author": "Eckhart Tolle"
  },
  {
    "text": "Thinking about swimming is not swimming.",
    "author": "Anonymous"
  },
  {
    "text": "A good plan executed today beats a perfect plan tomorrow.",
    "author": "Anonymous"
  },
  {
    "text": "The best way out is always through.",
    "author": "Robert Frost"
  },
  {
    "text": "Deliberate practice fills gaps that passion cannot.",
    "author": "Anonymous"
  },
  {
    "text": "Order your inner life; the outer will follow its lead.",
    "author": "Anonymous"
  },
  {
    "text": "In the middle of difficulty lies opportunity.",
    "author": "Albert Einstein"
  },
  {
    "text": "He who conquers himself is the mightiest warrior.",
    "author": "Confucius"
  },
  {
    "text": "A gentle river carves the hardest stone.",
    "author": "Anonymous"
  },
  {
    "text": "Act without expectation.",
    "author": "Lao Tzu"
  },
  {
    "text": "Measure progress in millimeters when miles feel impossible.",
    "author": "Anonymous"
  },
  {
    "text": "You do not rise to the level of your goals; you fall to the level of your systems.",
    "author": "James Clear"
  },
  {
    "text": "An unexamined habit runs your life without your permission.",
    "author": "Anonymous"
  },
  {
    "text": "Lose an hour in the morning and you will spend all day hunting for it.",
    "author": "Richard Whately"
  },
  {
    "text": "Live each season as it passes; breathe the air, drink the drink.",
    "author": "Henry David Thoreau"
  },
  {
    "text": "Excellence is never an accident.",
    "author": "Aristotle"
  },
  {
    "text": "Silence is a source of great strength.",
    "author": "Lao Tzu"
  },
  {
    "text": "Every artist was first an amateur.",
    "author": "Ralph Waldo Emerson"
  },
  {
    "text": "The gap between who you are and who you want to be is closed by practice.",
    "author": "Anonymous"
  },
  {
    "text": "Train your attention and the rest trains itself.",
    "author": "Anonymous"
  },
  {
    "text": "Begin anywhere.",
    "author": "John Cage"
  },
  {
    "text": "The groundwork of all happiness is good health and a quiet mind.",
    "author": "Anonymous"
  },
  {
    "text": "Nothing great was ever achieved without enthusiasm.",
    "author": "Ralph Waldo Emerson"
  },
  {
    "text": "Tend the small flame; storms cannot blow out a bonfire.",
    "author": "Anonymous"
  },
  {
    "text": "What the superior man seeks is in himself.",
    "author": "Confucius"
  },
  {
    "text": "Consistency compounds; intensity fades.",
    "author": "Anonymous"
  },
  {
    "text": "Small habits are the compound interest of self-improvement.",
    "author": "James Clear"
  },
  {
    "text": "Routine is not a cage; it is the trellis on which growth climbs.",
    "author": "Anonymous"
  },
  {
    "text": "A calm mind is the soil where good decisions take root.",
    "author": "Anonymous"
  },
  {
    "text": "Every morning is a chance to lay one more brick quietly.",
    "author": "Anonymous"
  },
  {
    "text": "Silence is not empty; it is full of unspoken discipline.",
    "author": "Anonymous"
  },
  {
    "text": "What you do every day matters more than what you do once in a while.",
    "author": "Gretchen Rubin"
  },
  {
    "text": "The long way around is often the shortest way forward.",
    "author": "Anonymous"
  },
  {
    "text": "We are what we repeatedly do; excellence, then, is not an act.",
    "author": "Aristotle"
  },
  {
    "text": "Stillness is not stagnation; it is a river resting before the falls.",
    "author": "Anonymous"
  },
  {
    "text": "A single focused hour outweighs a scattered day.",
    "author": "Anonymous"
  },
  {
    "text": "Sow a thought, reap an action; sow an action, reap a character.",
    "author": "William James"
  },
  {
    "text": "The present moment is the only place where work actually happens.",
    "author": "Anonymous"
  },
  {
    "text": "Waste no more time arguing what a good person should be; be one.",
    "author": "Marcus Aurelius"
  },
  {
    "text": "Great things are done by a series of small things brought together.",
    "author": "Vincent van Gogh"
  },
  {
    "text": "Patience is the art of hoping quietly.",
    "author": "Luc de Clapiers"
  },
  {
    "text": "Mastery whispers; it does not shout.",
    "author": "Anonymous"
  },
  {
    "text": "Steady dripping wears away stone.",
    "author": "Lucretius"
  },
  {
    "text": "The strongest trees grow where the wind is patient.",
    "author": "Anonymous"
  },
  {
    "text": "If you correct your mind, the rest of your life will fall into place.",
    "author": "Lao Tzu"
  },
  {
    "text": "Each step forward is practice for the next.",
    "author": "Anonymous"
  },
  {
    "text": "Discipline is remembering what you want.",
    "author": "David Campbell"
  },
  {
    "text": "You can't cross the sea merely by standing and staring at the water.",
    "author": "Rabindranath Tagore"
  },
  {
    "text": "Deliberate rest is part of deliberate practice.",
    "author": "Anonymous"
  },
  {
    "text": "Men acquire a particular quality by constantly acting in a particular way.",
    "author": "Aristotle"
  },
  {
    "text": "Momentum is built in private, long before it is seen in public.",
    "author": "Anonymous"
  },
  {
    "text": "Nothing is particularly hard if you divide it into small steps.",
    "author": "Henry Ford"
  },
  {
    "text": "The quality of one hour of attention changes the whole of a day.",
    "author": "Anonymous"
  },
  {
    "text": "Every day, the seeds you buried yesterday press upward.",
    "author": "Anonymous"
  },
  {
    "text": "The impediment to action advances action; what stands in the way becomes the way.",
    "author": "Marcus Aurelius"
  },
  {
    "text": "Cultivate the habit of being grateful for every good thing that comes to you.",
    "author": "Ralph Waldo Emerson"
  },
  {
    "text": "Water is fluid yet wears down the hardest rock.",
    "author": "Lao Tzu"
  },
  {
    "text": "A schedule defends from chaos and whim.",
    "author": "Annie Dillard"
  },
  {
    "text": "What is planted in each person's soul will sprout.",
    "author": "Rumi"
  },
  {
    "text": "Focus is the art of saying no to almost everything.",
    "author": "Anonymous"
  },
  {
    "text": "Think in the morning, act in the noon, read in the evening.",
    "author": "William Blake"
  },
  {
    "text": "Slow is smooth; smooth is fast.",
    "author": "Anonymous"
  },
  {
    "text": "The first hour of the morning governs the rest of the day.",
    "author": "Henry Ward Beecher"
  },
  {
    "text": "Not all those who wander are lost, but all who drift without intention are.",
    "author": "Anonymous"
  },
  {
    "text": "Growth does not announce itself; it simply appears one quiet morning.",
    "author": "Anonymous"
  },
  {
    "text": "Even a small star shines in its own darkness.",
    "author": "Anonymous"
  },
  {
    "text": "Tend the small flame. Wildfires were never lit all at once.",
    "author": "Anonymous"
  },
  {
    "text": "We are what we repeatedly do. Excellence, then, is not an act but a habit.",
    "author": "Aristotle"
  },
  {
    "text": "Stillness is not emptiness. It is where clarity is made.",
    "author": "Anonymous"
  },
  {
    "text": "Discipline is choosing the discomfort that serves you.",
    "author": "Anonymous"
  },
  {
    "text": "Root yourself in routine and grow toward the unexpected.",
    "author": "Anonymous"
  },
  {
    "text": "The usefulness of a cup is in its emptiness.",
    "author": "Lao Tzu"
  },
  {
    "text": "Compound interest applies equally to knowledge and to character.",
    "author": "Anonymous"
  },
  {
    "text": "Make the most of yourself, for that is all there is of you.",
    "author": "Ralph Waldo Emerson"
  },
  {
    "text": "A quiet mind hears what a busy mind talks over.",
    "author": "Anonymous"
  },
  {
    "text": "Each morning is an unopened ledger. Fill it deliberately.",
    "author": "Anonymous"
  },
  {
    "text": "Routine is the architecture inside which freedom is built.",
    "author": "Anonymous"
  },
  {
    "text": "Patience is the long lever that moves the heaviest things.",
    "author": "Anonymous"
  },
  {
    "text": "Water wears stone not by force but by faithful return.",
    "author": "Anonymous"
  },
  {
    "text": "The object of life is not to be on the side of the majority.",
    "author": "Marcus Aurelius"
  },
  {
    "text": "Progress hides inside the gap between showing up and quitting.",
    "author": "Anonymous"
  },
  {
    "text": "Small acts, when multiplied by many people, can transform the world.",
    "author": "Howard Zinn"
  },
  {
    "text": "A single thread, woven daily, becomes the cloth of a life.",
    "author": "Anonymous"
  },
  {
    "text": "The quality of your attention shapes the quality of your hours.",
    "author": "Anonymous"
  },
  {
    "text": "Calmness is the cradle of power.",
    "author": "Josiah Gilbert Holland"
  },
  {
    "text": "The harvest you seek is planted in today's unremarkable effort.",
    "author": "Anonymous"
  },
  {
    "text": "He who knows others is wise; he who knows himself is enlightened.",
    "author": "Lao Tzu"
  },
  {
    "text": "Brevity of action is not laziness — it is precision.",
    "author": "Anonymous"
  },
  {
    "text": "Attention, taken to its highest form, is the same thing as prayer.",
    "author": "Simone Weil"
  },
  {
    "text": "Drift is the enemy of growth. Intention is the rudder.",
    "author": "Anonymous"
  },
  {
    "text": "Each small step lands on soil the next step needs.",
    "author": "Anonymous"
  },
  {
    "text": "The soul becomes dyed with the color of its thoughts.",
    "author": "Marcus Aurelius"
  },
  {
    "text": "Slow is not the opposite of progress. Slow is often progress.",
    "author": "Anonymous"
  },
  {
    "text": "To affect the quality of the day — that is the art of life.",
    "author": "Henry David Thoreau"
  },
  {
    "text": "Consistency is a vote cast daily for the person you are becoming.",
    "author": "Anonymous"
  },
  {
    "text": "Do not seek that things should happen as you wish, but wish as they happen.",
    "author": "Epictetus"
  },
  {
    "text": "The foundation of every great thing is a boring Tuesday repeated.",
    "author": "Anonymous"
  },
  {
    "text": "Anchor yourself to process and let outcomes follow like a tide.",
    "author": "Anonymous"
  },
  {
    "text": "Every master was once a beginner who simply kept returning.",
    "author": "Anonymous"
  },
  {
    "text": "It is not length of life but depth of life that matters.",
    "author": "Ralph Waldo Emerson"
  },
  {
    "text": "The gap between intention and action is where character is forged.",
    "author": "Anonymous"
  },
  {
    "text": "Simplicity, patience, compassion — these are your greatest treasures.",
    "author": "Lao Tzu"
  },
  {
    "text": "Seasons change without announcement. So does the disciplined self.",
    "author": "Anonymous"
  },
  {
    "text": "An unexamined habit is a quiet architect of your future.",
    "author": "Anonymous"
  },
  {
    "text": "Small acts, repeated faithfully, carve canyons.",
    "author": "Anonymous"
  },
  {
    "text": "Stillness is not absence. It is the ground from which clear action grows.",
    "author": "Anonymous"
  },
  {
    "text": "We are what we repeatedly do. Excellence is not an act but a habit.",
    "author": "Aristotle"
  },
  {
    "text": "Tend the hours and the years will tend themselves.",
    "author": "Anonymous"
  },
  {
    "text": "Each morning we are born again. What we do today matters most.",
    "author": "Anonymous"
  },
  {
    "text": "The mind that is not baffled is not employed.",
    "author": "Wendell Berry"
  },
  {
    "text": "Do not hurry, do not rest.",
    "author": "Johann Wolfgang von Goethe"
  },
  {
    "text": "Dripping water hollows out stone, not through force but persistence.",
    "author": "Ovid"
  },
  {
    "text": "A quiet discipline outlasts every burst of loud ambition.",
    "author": "Anonymous"
  },
  {
    "text": "The seed does not announce its becoming. It simply grows.",
    "author": "Anonymous"
  },
  {
    "text": "Write your intentions in ink; let your actions speak in stone.",
    "author": "Anonymous"
  },
  {
    "text": "Begin anywhere. The path reveals itself beneath moving feet.",
    "author": "Anonymous"
  },
  {
    "text": "Concentrate all your thoughts on the task at hand.",
    "author": "Alexander Graham Bell"
  },
  {
    "text": "Chains of habit are too light to feel until they are too heavy to break.",
    "author": "Warren Buffett"
  },
  {
    "text": "What is done in love is done well.",
    "author": "Vincent van Gogh"
  },
  {
    "text": "Let your roots grow deep before you ask your branches to reach far.",
    "author": "Anonymous"
  },
  {
    "text": "The consistent candle lights a room long after the flare has faded.",
    "author": "Anonymous"
  },
  {
    "text": "Slow, steady breath. Slow, steady progress. The rhythm is the same.",
    "author": "Anonymous"
  },
  {
    "text": "Mastery hides inside the ordinary hours most people overlook.",
    "author": "Anonymous"
  },
  {
    "text": "The afternoon knows what the morning never suspected.",
    "author": "Robert Frost"
  },
  {
    "text": "Build rituals, not rules. One invites, the other only demands.",
    "author": "Anonymous"
  },
  {
    "text": "The groundwork of all happiness is health.",
    "author": "Leigh Hunt"
  },
  {
    "text": "Layer by layer, even mountains are built by the patient earth.",
    "author": "Anonymous"
  },
  {
    "text": "Act well at the moment, and you have performed a good action forever.",
    "author": "Johann Kaspar Lavater"
  },
  {
    "text": "Attend to one thing with full presence. That is enough.",
    "author": "Anonymous"
  },
  {
    "text": "Things do not grow better; they remain as they are, and we grow better.",
    "author": "Johann von Schiller"
  },
  {
    "text": "The river does not rush — and still it shapes the land.",
    "author": "Anonymous"
  },
  {
    "text": "Nothing in life is to be feared, only to be understood.",
    "author": "Marie Curie"
  },
  {
    "text": "Let the soft animal of your body love what it loves.",
    "author": "Mary Oliver"
  },
  {
    "text": "Where focus goes, energy flows and growth follows.",
    "author": "Anonymous"
  },
  {
    "text": "The humble seed trusts the season. So can you.",
    "author": "Anonymous"
  },
  {
    "text": "Rest is not idleness. It is the field lying fallow before the harvest.",
    "author": "Anonymous"
  },
  {
    "text": "Knowledge is learning something every day. Wisdom is letting go.",
    "author": "Zen Proverb"
  },
  {
    "text": "We first make our habits, then our habits make us.",
    "author": "John Dryden"
  },
  {
    "text": "The present moment is the only moment available to us.",
    "author": "Thich Nhat Hanh"
  },
  {
    "text": "Small hinges swing the largest doors.",
    "author": "W. Clement Stone"
  },
  {
    "text": "Give your best to the moment and the moment gives back.",
    "author": "Anonymous"
  },
  {
    "text": "The gap between who you are and who you could be is filled by daily practice.",
    "author": "Anonymous"
  },
  {
    "text": "Small corrections, made consistently, outperform grand intentions every time.",
    "author": "Anonymous"
  },
  {
    "text": "Stillness is not emptiness. It is the ground from which clear action grows.",
    "author": "Anonymous"
  },
  {
    "text": "Routine is the architecture of a life well lived.",
    "author": "Anonymous"
  },
  {
    "text": "The river carves the canyon not by force but by returning again and again.",
    "author": "Anonymous"
  },
  {
    "text": "Wealth is the ability to fully experience life.",
    "author": "Henry David Thoreau"
  },
  {
    "text": "A mind that is not cluttered can see what is actually there.",
    "author": "Anonymous"
  },
  {
    "text": "What you tend to daily will outlast what you attempt once grandly.",
    "author": "Anonymous"
  },
  {
    "text": "Discipline is remembering what you want most over what you want now.",
    "author": "Anonymous"
  },
  {
    "text": "The man who moves a mountain begins by carrying away small stones.",
    "author": "Confucius"
  },
  {
    "text": "Attention is the rarest and purest form of generosity — including to yourself.",
    "author": "Simone Weil"
  },
  {
    "text": "Each habit is a vote cast for the person you are becoming.",
    "author": "James Clear"
  },
  {
    "text": "Slow down enough to notice what is already working within you.",
    "author": "Anonymous"
  },
  {
    "text": "Growth does not announce itself. It accumulates quietly, then becomes undeniable.",
    "author": "Anonymous"
  },
  {
    "text": "The present moment is where skill is built and where calm is found.",
    "author": "Anonymous"
  },
  {
    "text": "Mastery asks not for bursts of brilliance but for patient, steady hands.",
    "author": "Anonymous"
  },
  {
    "text": "Plant your habits in spring and harvest your character in autumn.",
    "author": "Anonymous"
  },
  {
    "text": "The obstacle is not in the path. The obstacle is the path.",
    "author": "Marcus Aurelius"
  },
  {
    "text": "A calm mind is not a passive mind. It is a prepared one.",
    "author": "Anonymous"
  },
  {
    "text": "Progress is the quiet sum of unnoticed efforts.",
    "author": "Anonymous"
  },
  {
    "text": "In the middle of difficulty lies opportunity — but you must be steady enough to see it.",
    "author": "Anonymous"
  },
  {
    "text": "The quality of your mornings shapes the quality of your years.",
    "author": "Anonymous"
  },
  {
    "text": "To know what you know and know what you do not know — that is knowledge.",
    "author": "Confucius"
  },
  {
    "text": "Perseverance is not a long race; it is many short races run one after another.",
    "author": "Walter Elliot"
  },
  {
    "text": "Anchor your day to a single small act done with full presence.",
    "author": "Anonymous"
  },
  {
    "text": "Finish each day and be done with it. Tomorrow is a new day.",
    "author": "Ralph Waldo Emerson"
  },
  {
    "text": "Tension is who you think you should be. Relaxation is who you are.",
    "author": "Lao Tzu"
  },
  {
    "text": "Every artist was first an amateur who kept showing up.",
    "author": "Anonymous"
  },
  {
    "text": "The seeds of tomorrow's strength are planted in today's quiet effort.",
    "author": "Anonymous"
  },
  {
    "text": "Knowing others is intelligence; knowing yourself is true wisdom.",
    "author": "Lao Tzu"
  },
  {
    "text": "Focus is the art of saying a gentle no to almost everything else.",
    "author": "Anonymous"
  },
  {
    "text": "Character is the long shadow cast by repeated choices.",
    "author": "Anonymous"
  },
  {
    "text": "He who is not courageous enough to take risks will accomplish nothing in life.",
    "author": "Muhammad Ali"
  },
  {
    "text": "A gentle consistency is more powerful than a fierce inconsistency.",
    "author": "Anonymous"
  },
  {
    "text": "Live in the sunshine, swim the sea, drink the wild air.",
    "author": "Ralph Waldo Emerson"
  },
  {
    "text": "The mind trained to return — to breath, to task, to presence — is the mind that grows.",
    "author": "Anonymous"
  },
  {
    "text": "Nothing is particularly hard if you divide it into small pieces.",
    "author": "Henry Ford"
  },
  {
    "text": "Depth comes from staying when the surface no longer feels new.",
    "author": "Anonymous"
  },
  {
    "text": "Simplicity is the ultimate sophistication — in thought, in habit, in life.",
    "author": "Leonardo da Vinci"
  },
  {
    "text": "Build the habit quietly. Let the results speak loudly later.",
    "author": "Anonymous"
  },
  {
    "text": "The unexamined habit is the one that quietly steers your life.",
    "author": "Anonymous"
  },
  {
    "text": "Small actions, faithfully repeated, outweigh grand intentions.",
    "author": "Anonymous"
  },
  {
    "text": "Lose an hour in the morning and you will spend all day looking for it.",
    "author": "Richard Whately"
  },
  {
    "text": "Attention is the rarest and purest form of generosity—give it to your work.",
    "author": "Simone Weil"
  },
  {
    "text": "Mastery is not a destination; it is a direction chosen each morning.",
    "author": "Anonymous"
  },
  {
    "text": "The quieter you become, the more clearly you can hear what matters.",
    "author": "Anonymous"
  },
  {
    "text": "Each day is a small life; live it with care.",
    "author": "Anonymous"
  },
  {
    "text": "Discipline is choosing what you want most over what you want now.",
    "author": "Abraham Lincoln"
  },
  {
    "text": "Nothing in nature hurries, yet everything arrives on time.",
    "author": "Lao Tzu"
  },
  {
    "text": "A habit is a vote cast for the person you are becoming.",
    "author": "James Clear"
  },
  {
    "text": "The soil of good work is prepared long before the harvest is seen.",
    "author": "Anonymous"
  },
  {
    "text": "Think in decades, act in days.",
    "author": "Anonymous"
  },
  {
    "text": "Still water reflects clearly. A settled mind works the same way.",
    "author": "Anonymous"
  },
  {
    "text": "Endure today's discomfort; inhabit tomorrow's strength.",
    "author": "Anonymous"
  },
  {
    "text": "Compounding favors those who refuse to interrupt it.",
    "author": "Anonymous"
  },
  {
    "text": "Calm is a superpower grown slowly in the soil of consistent practice.",
    "author": "Anonymous"
  },
  {
    "text": "A river cuts rock not by force but by patient, unbroken return.",
    "author": "Anonymous"
  },
  {
    "text": "The seed does not debate the season; it simply prepares.",
    "author": "Anonymous"
  },
  {
    "text": "Look well into thyself; there is a source which will always spring up.",
    "author": "Marcus Aurelius"
  },
  {
    "text": "Progress is built in layers too thin to see until you step back.",
    "author": "Anonymous"
  },
  {
    "text": "One day or day one—the choice reshapes everything that follows.",
    "author": "Anonymous"
  },
  {
    "text": "An ounce of practice is worth more than a ton of preaching.",
    "author": "Mahatma Gandhi"
  },
  {
    "text": "Slow is smooth; smooth, over time, becomes swift.",
    "author": "Anonymous"
  },
  {
    "text": "To know what to neglect is the beginning of wisdom.",
    "author": "William James"
  },
  {
    "text": "The mind that returns calmly after distraction grows stronger each time.",
    "author": "Anonymous"
  },
  {
    "text": "Dripping water hollows out stone—not by force but by frequency.",
    "author": "Ovid"
  },
  {
    "text": "Build your identity quietly, brick by brick, before the world notices.",
    "author": "Anonymous"
  },
  {
    "text": "Act without expectation; work without ceasing to work.",
    "author": "Lao Tzu"
  },
  {
    "text": "Measure your effort in years, your rest in breaths.",
    "author": "Anonymous"
  },
  {
    "text": "Men's natures are alike; it is their habits that separate them.",
    "author": "Confucius"
  },
  {
    "text": "The fruit of patience is sweet precisely because it was waited for.",
    "author": "Anonymous"
  },
  {
    "text": "It is not enough to be busy—the question is, what are we busy about?",
    "author": "Henry David Thoreau"
  },
  {
    "text": "Consistency is the bridge between ambition and arrival.",
    "author": "Anonymous"
  },
  {
    "text": "To do two things at once is to do neither.",
    "author": "Publilius Syrus"
  },
  {
    "text": "The greatest wealth is a poverty of desires, quietly sustained.",
    "author": "Anonymous"
  },
  {
    "text": "Every master was once a beginner who simply did not stop.",
    "author": "Anonymous"
  },
  {
    "text": "Finish each day and be done with it—tomorrow is a new beginning.",
    "author": "Ralph Waldo Emerson"
  },
  {
    "text": "A mind focused on one thing at a time is already ahead.",
    "author": "Anonymous"
  },
  {
    "text": "Cultivate the habit of attention and try to gain opportunities to reflect.",
    "author": "Robert Louis Stevenson"
  },
  {
    "text": "Your future self is being shaped right now, in this ordinary moment.",
    "author": "Anonymous"
  },
  {
    "text": "Growth whispers; only those who are quiet enough hear it.",
    "author": "Anonymous"
  },
  {
    "text": "The longest journey proceeds from a single, unhurried step.",
    "author": "Anonymous"
  },
  {
    "text": "A calm exterior is the proof of an interior long tended.",
    "author": "Anonymous"
  },
  {
    "text": "Tend the small flame daily. Wildfires were never the goal.",
    "author": "Anonymous"
  },
  {
    "text": "We are what we repeatedly do. Excellence, then, is not an act.",
    "author": "Aristotle"
  },
  {
    "text": "Stillness is not the absence of motion. It is motion in its right place.",
    "author": "Anonymous"
  },
  {
    "text": "A single step, honestly taken, is worth a thousand plans.",
    "author": "Anonymous"
  },
  {
    "text": "Routine is the quiet scaffolding of an extraordinary life.",
    "author": "Anonymous"
  },
  {
    "text": "Depth comes to those who return to the same well each morning.",
    "author": "Anonymous"
  },
  {
    "text": "Sow a habit, reap a character; sow a character, reap a destiny.",
    "author": "William James"
  },
  {
    "text": "Every day is a workshop. Show up with clean tools.",
    "author": "Anonymous"
  },
  {
    "text": "The present moment is the only lever you actually hold.",
    "author": "Anonymous"
  },
  {
    "text": "Rivers do not force their way. They find the path of patient persistence.",
    "author": "Anonymous"
  },
  {
    "text": "Calm is not weakness. It is precision in a noisy world.",
    "author": "Anonymous"
  },
  {
    "text": "A mind at ease with its limits grows faster than one at war.",
    "author": "Anonymous"
  },
  {
    "text": "He who is not everyday conquering some fear has not learned the secret of life.",
    "author": "Ralph Waldo Emerson"
  },
  {
    "text": "Mastery whispers. It has no need to announce itself.",
    "author": "Anonymous"
  },
  {
    "text": "The seed does not argue with the soil. It simply roots.",
    "author": "Anonymous"
  },
  {
    "text": "Begin anywhere. The map reveals itself to the one who walks.",
    "author": "Anonymous"
  },
  {
    "text": "Act with restraint and you will accomplish everything.",
    "author": "Lao Tzu"
  },
  {
    "text": "Growth is rarely loud. Listen for the quiet shifts.",
    "author": "Anonymous"
  },
  {
    "text": "Every keystroke in the direction of your craft is a vote for who you become.",
    "author": "Anonymous"
  },
  {
    "text": "A tree that bends in wind is still a tree that stands.",
    "author": "Anonymous"
  },
  {
    "text": "The disciplined mind is not a cage. It is a lens.",
    "author": "Anonymous"
  },
  {
    "text": "Patience is not waiting. It is working without watching the clock.",
    "author": "Anonymous"
  },
  {
    "text": "To arrive somewhere new, learn first to stay somewhere fully.",
    "author": "Anonymous"
  },
  {
    "text": "Awareness is the soil. Discipline is the rain. Growth is inevitable.",
    "author": "Anonymous"
  },
  {
    "text": "The soul is dyed the color of its thoughts. Choose deliberately.",
    "author": "Marcus Aurelius"
  },
  {
    "text": "Small done is always greater than large planned.",
    "author": "Anonymous"
  },
  {
    "text": "Eat little, sleep soundly, work steadily. Nature needs no more.",
    "author": "Anonymous"
  },
  {
    "text": "The archer who rushes the breath misses the target every time.",
    "author": "Anonymous"
  },
  {
    "text": "I learned silence from the talkative and diligence from the idle.",
    "author": "Kahlil Gibran"
  },
  {
    "text": "Consistency is proof that you believe in the destination.",
    "author": "Anonymous"
  },
  {
    "text": "Not all growth is visible. Roots spread long before branches rise.",
    "author": "Anonymous"
  },
  {
    "text": "Slow is the pace of things that last.",
    "author": "Anonymous"
  },
  {
    "text": "To know what you can control is to already be free.",
    "author": "Anonymous"
  },
  {
    "text": "The best time to build a habit was yesterday. The useful time is now.",
    "author": "Anonymous"
  },
  {
    "text": "Nature does not rush, yet everything is accomplished.",
    "author": "Lao Tzu"
  },
  {
    "text": "Habits are the invisible architecture of daily life.",
    "author": "Gretchen Rubin"
  },
  {
    "text": "Measure your wealth in mornings spent on what matters.",
    "author": "Anonymous"
  },
  {
    "text": "A clear intention held lightly travels farther than a desperate one.",
    "author": "Anonymous"
  },
  {
    "text": "The fox has many tricks; the hedgehog has one. One is often enough.",
    "author": "Anonymous"
  },
  {
    "text": "Nothing reinforces good work like the quiet pleasure of having done it.",
    "author": "Anonymous"
  },
  {
    "text": "Live in each season as it passes; breathe the air, taste the fruit.",
    "author": "Henry David Thoreau"
  },
  {
    "text": "The strongest habits are invisible to the one who holds them.",
    "author": "Anonymous"
  },
  {
    "text": "Progress is a direction, not a destination. Keep facing it.",
    "author": "Anonymous"
  },
  {
    "text": "The gap between who you are and who you become is filled with small, kept promises.",
    "author": "Anonymous"
  },
  {
    "text": "First forget inspiration. Habit is the architect of all worthy things.",
    "author": "Anonymous"
  },
  {
    "text": "Stillness is not the absence of motion. It is the ground from which clear motion grows.",
    "author": "Anonymous"
  },
  {
    "text": "A good plan executed daily outlasts a great plan executed occasionally.",
    "author": "Anonymous"
  },
  {
    "text": "We are what we repeatedly do. Excellence, then, is not an act, but a habit.",
    "author": "Aristotle"
  },
  {
    "text": "Routine is not the enemy of creativity; it is the soil in which creativity roots.",
    "author": "Anonymous"
  },
  {
    "text": "Dripping water hollows out stone, not through force but through persistence.",
    "author": "Ovid"
  },
  {
    "text": "Attend to what is small and the large will attend to itself.",
    "author": "Anonymous"
  },
  {
    "text": "Your future self is built in moments your present self finds unremarkable.",
    "author": "Anonymous"
  },
  {
    "text": "The quieter you become, the more you are able to hear.",
    "author": "Rumi"
  },
  {
    "text": "Measure progress in direction, not in distance.",
    "author": "Anonymous"
  },
  {
    "text": "In the middle of difficulty lies opportunity cultivated by preparation.",
    "author": "Anonymous"
  },
  {
    "text": "Whoever is in a hurry shows that the thing he is about is too big for him.",
    "author": "Lord Chesterfield"
  },
  {
    "text": "A single thread, pulled daily, weaves a life worth wearing.",
    "author": "Anonymous"
  },
  {
    "text": "The secret of getting ahead is getting started on what matters least urgently.",
    "author": "Anonymous"
  },
  {
    "text": "How we spend our days is, of course, how we spend our lives.",
    "author": "Annie Dillard"
  },
  {
    "text": "Tend to the process. The harvest decides itself.",
    "author": "Anonymous"
  },
  {
    "text": "Calm is not a mood. It is a practiced architecture of mind.",
    "author": "Anonymous"
  },
  {
    "text": "Each day is a workshop. Bring your tools; leave something finished.",
    "author": "Anonymous"
  },
  {
    "text": "Lose an hour in the morning and you will be hunting for it all day.",
    "author": "Richard Whately"
  },
  {
    "text": "A river cuts through rock not because of power but because of patient return.",
    "author": "Anonymous"
  },
  {
    "text": "Begin anywhere. Every beginning compounds.",
    "author": "Anonymous"
  },
  {
    "text": "What you do every day matters more than what you do every once in a while.",
    "author": "Gretchen Rubin"
  }
];

export const quoteForDay = (date = new Date()) => {
  // Day-of-year (0-365) → quotes[(doy + seed) % length]
  const start = new Date(date.getFullYear(), 0, 0);
  const diff = (date - start) + ((start.getTimezoneOffset() - date.getTimezoneOffset()) * 60 * 1000);
  const doy = Math.floor(diff / (1000 * 60 * 60 * 24));
  return QUOTES[((doy % QUOTES.length) + QUOTES.length) % QUOTES.length];
};
